import _ from 'lodash'
import React, { useState, useLayoutEffect } from 'react'
import { Button, FormControl, FormGroup, Label } from 'react-bootstrap'

import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

import { SwitchButtonWithTrigger } from 'plugin-generic-components/shared/components/components'
import { PresenterProps } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'

import { Escalation, RemoveEscalation, UpdateMode } from './style'

type IUpdateModeJsonConfigConfig = {
    degradationContribution: number | string
}
type IEditorEscalation = import('plugin-codaf-risk-ext-bowtie/types').IEscalationFactor & { uid: string }

export const QualitativeLopaScaling: React.FC<PresenterProps> = ({ barrierPointers, onChanged, editable }) => {
    // PASER WILL BE DONE ATE UPDATE MODE CONTROLLER

    const escalationdegradationContributionValidator = (
        updateModeJsonConfig: IUpdateModeJsonConfigConfig
    ): 'error' | 'success' => {
        return !updateModeJsonConfig?.degradationContribution ||
            isNaN(updateModeJsonConfig?.degradationContribution as any) ||
            updateModeJsonConfig?.degradationContribution < 0 ||
            updateModeJsonConfig?.degradationContribution > 100
            ? 'error'
            : 'success'
    }

    useLayoutEffect(() => {
        if (barrierPointers) {
            if (!barrierPointers[0].escalations || barrierPointers[0].escalations.length === 0) {
                handleAddEscalationFactor()
            }
        }
    }, [barrierPointers])

    const onDeleteEscalationRequest = (escalationEdit: IEditorEscalation): void => {
        if (barrierPointers[0].root) {
            const newArray = (barrierPointers[0].escalations as IEditorEscalation[]).filter(e => {
                if (e.id) {
                    return e.id !== escalationEdit.id
                } else {
                    return e.uid !== escalationEdit.uid
                }
            })
            barrierPointers[0].escalations = [...newArray]
        } else {
            barrierPointers.forEach(bar => {
                const newArray = (bar.escalations as IEditorEscalation[]).filter(e => {
                    if (e.id) {
                        return e.id !== escalationEdit.id
                    } else {
                        return e.uid !== escalationEdit.uid
                    }
                })
                bar.escalations = [...newArray]
            })
        }

        onChanged()
    }

    const handleAddEscalationFactor = (): void => {
        // const recursiveArrayOfBarrier = handleGetRecursiveSearch(item[0] as IEditorBarrier)

        const escalationToAdd: IEditorEscalation = {
            id: null,
            uid: _.uniqueId(),
            name: null,
            updateModeJsonConfig: { degradationContribution: null },
            barriers: []
            // getFather: item[0] as IEditorBarrier
        }

        if (barrierPointers[0].root) {
            if (!barrierPointers[0].escalations.length) {
                barrierPointers[0].escalations = [escalationToAdd]
            } else {
                barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
            }
        } else {
            if (barrierPointers[0].id) {
                barrierPointers.forEach(bar => {
                    if (!bar.escalations.length) {
                        bar.escalations = [escalationToAdd]
                    } else {
                        bar.escalations = [...bar.escalations, escalationToAdd]
                    }
                })
            } else {
                if (!barrierPointers[0].escalations.length) {
                    barrierPointers[0].escalations = [escalationToAdd]
                } else {
                    barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
                }
            }
        }

        onChanged()
    }

    const divideBy = (value: string, divisor: number): string => {
        if (value === null || value === undefined || value === '') {
            return value
        }
        let newValue = parseFloat(value) / divisor
        if (isNaN(newValue)) {
            return ''
        }
        return String(newValue)
    }

    const multiplyBy = (value: string | number, multiplier: number): string | number => {
        if (value === null || value === undefined || value === '') {
            return value
        }
        if (typeof value === 'string') {
            let newValue = parseFloat(value) * multiplier
            if (isNaN(newValue)) {
                return ''
            }
            return String(newValue)
        }

        let newValue = ((value as unknown) as number) * multiplier
        return newValue
    }

    const escalationsFields = barrierPointers[0].escalations.map((escalation, index) => {
        return (
            <Escalation key={index}>
                <FormGroup validationState={barrierPointers[0].escalations[index].name ? 'success' : 'error'}>
                    <Label required className="control-label">
                        {i18n('Escalation Factor')} #{index + 1}*
                    </Label>
                    <FormControl
                        readOnly={!editable}
                        type="text"
                        componentClass="textarea"
                        onChange={e => {
                            barrierPointers.forEach(
                                el => (el.escalations[index].name = (e.target as HTMLInputElement).value)
                            )
                            onChanged()
                        }}
                        id="barrierEditor-barrierEditModal-field-lopaScaling-escalationFactor"
                        value={escalation.name}
                    />
                </FormGroup>
                <FormGroup
                    validationState={escalationdegradationContributionValidator(
                        barrierPointers[0].escalations[index].updateModeJsonConfig as IUpdateModeJsonConfigConfig
                    )}
                    className="escalationfactor-ic-box"
                >
                    <Label required className="control-label">
                        <LiveTooltip content={i18n('Degradation Contribution')} position="left">
                            <div> DC %*</div>
                        </LiveTooltip>
                    </Label>
                    <FormControl
                        readOnly={!editable}
                        type="number"
                        componentClass="textarea"
                        onChange={e => {
                            barrierPointers.forEach(
                                el =>
                                    ((el.escalations[index].updateModeJsonConfig as IUpdateModeJsonConfigConfig) = {
                                        degradationContribution: divideBy((e.target as HTMLInputElement).value, 100)
                                    })
                            )
                            onChanged()
                        }}
                        id="barrierEditor-barrierEditModal-field-lopaScaling-escalationFactor-initial-contribution"
                        value={multiplyBy(
                            (escalation?.updateModeJsonConfig as IUpdateModeJsonConfigConfig)?.degradationContribution,
                            100
                        )}
                    />
                </FormGroup>
                {editable && (
                    <RemoveEscalation>
                        {barrierPointers[0].escalations.length > 1 && (
                            <button onClick={() => onDeleteEscalationRequest(escalation as IEditorEscalation)}>
                                <i className="far fa-trash-alt"></i>
                            </button>
                        )}
                    </RemoveEscalation>
                )}
            </Escalation>
        )
    })

    return (
        <>
            <UpdateMode>
                <SwitchButtonWithTrigger
                    id={'escalationFactor'}
                    label={i18n('Escalation Factors')}
                    value={true}
                    disabled
                />
                <div className="escalations">{escalationsFields}</div>
                <Button
                    disabled={!editable}
                    className="add-escalation-button"
                    bsStyle="primary"
                    onClick={handleAddEscalationFactor}
                >
                    <i className="fas fa-plus"></i> {i18n('add escalation')}
                </Button>
            </UpdateMode>
        </>
    )
}
